import { Col } from '../layout';
export default Col;



/** WEBPACK FOOTER **
 ** ./components/col/index.js
 **/